import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { DataManager, WebApiAdaptor, Query} from '@syncfusion/ej2-data';
import { RowDataBoundEventArgs, SelectionSettingsModel, ToolbarItems, PageSettingsModel, GridComponent } from '@syncfusion/ej2-angular-grids';
import { GridPageSettings, MenuFuncionCodes, PedidoDashboard } from '../../../../../src/app/shared/model';
import { MenuFuncionService, PedidoService } from '../../../../../src/app/shared/services';
import { SharedFunctions } from '../../../../../src/app/shared/shared.functions';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { EventEmiterService } from '../../../../../src/app/shared/services/event-emiter.service';

@Component({
  selector: 'app-vencimientoPedidos',
  templateUrl: './vencimientoPedidos.component.html',
  styleUrls: ['./vencimientoPedidos.component.scss']
})

export class VencimientoPedidosComponent implements OnInit {

  @ViewChild('grid')
  public grid: GridComponent;

  verSoloMisPendientesAprobacion: boolean = false;
  isValidating: boolean = false;
  canView: boolean = false;
  isSearching: boolean = false;
  formGroup: FormGroup;

  public data: DataManager;
  public query: Query;

  public selectionOptions: SelectionSettingsModel;
  public pageSizes: number[];
  public toolbarOptions: ToolbarItems[];
  public pageSettings: PageSettingsModel;

  private subscription: Subscription;

  constructor(
    private sharedFunctions: SharedFunctions,
    private pedidoService: PedidoService,
    private formBuilder: FormBuilder,
    private menuService: MenuFuncionService,
    private router: Router,
    private eventEmitterService: EventEmiterService
  ) {
    this.subscription = this.eventEmitterService.reloadView$.subscribe((value) => {
      this.loadView()
    });
  }

  ngOnInit(): void {
    this.isValidating = true;
    this.menuService.checkMenu(MenuFuncionCodes.DASHBOARD_PEDIDOS_VENCIMIENTO).subscribe(data => {
      this.isValidating = false;
      if (data != null && data.Success && data?.Result){
        this.canView = true;
        this.loadView();
      }
    },
    (err: HttpErrorResponse) => {
      this.isValidating = false;
      this.sharedFunctions.handleError(err);
    });
  }

  loadView() {
    this.pageSizes = GridPageSettings.PageSizeList ;
    this.pageSettings = { pageCount: GridPageSettings.PageCount, pageSize: this.pageSizes[0], pageSizes: this.pageSizes };


    this.data = new DataManager({
      url: this.pedidoService.getServiceUrl() + '/dashboard-pedidos-vencimientos',
      adaptor: new WebApiAdaptor(),
      headers: [this.pedidoService.getAuthorizationHeader(),this.pedidoService.getTenantHeader()]
    });
  }

  getTraduccion(value: string) {
    return this.sharedFunctions.getNombreMenuTenant(value);
  }

  onSearch() {
    this.setQueryParams();
    this.grid.refresh();
  }

  setQueryParams() {
    if (this.query == null)
      this.query = new Query();

    var index = this.query.params.findIndex(obj => obj.key === "VerSoloMisPendientesAprobacion");
    if (index >= 0)
      this.query.params[index].value = this.verSoloMisPendientesAprobacion.toString();
    else
      this.query.addParams("VerSoloMisPendientesAprobacion", this.verSoloMisPendientesAprobacion.toString());
  }

  onGridActionFailure(event: any): void {
    // this.sharedFunctions.showMessage("Ocurrió un error intentando realizar la búsqueda", "Error");
  }

  rowDataBound(args: RowDataBoundEventArgs) {
    const FechaLimite = 'FechaLimite';
    // Obtener la fecha de hoy
    const hoy: Date = new Date();
    const fechaLimiteToDate = new Date(args.data?.[FechaLimite]);
    // Agregarle 7 días
    const oneWeek: Date = new Date(hoy.getTime() + 7 * 24 * 60 * 60 * 1000);
    const twoWeek: Date = new Date(hoy.getTime() + 14 * 24 * 60 * 60 * 1000);
    // console.table(oneWeek >= fechaLimiteToDate)
    if (oneWeek >= fechaLimiteToDate) {
        args.row?.classList.add('critical');
    } else if (fechaLimiteToDate >= oneWeek && fechaLimiteToDate < twoWeek) {
        args.row?.classList.add('warning');
    } else {
        args.row?.classList.add('ok');
    }
  }

  edit(item: PedidoDashboard) {
    if (!item || item.PedidoId == null || item.PedidoId <= 0) {
      this.sharedFunctions.showMessage("Debe seleccionar un item", "Error");
      return false;
    }

    this.router.navigate(['pedido-edit', item.PedidoId]);
  }
}
